'use es6';

import { FINDER_PROJECTS_DEPLOY_REQUEST, FINDER_PROJECTS_DEPLOY_RECEIVE, FINDER_PROJECTS_DEPLOY_ERROR, FINDER_PROJECTS_CREATE_REQUEST, FINDER_PROJECTS_CREATE_ERROR, FINDER_PROJECTS_CREATE_RECEIVE, FINDER_PROJECTS_SET_ACTIVE_PROJECT_FOLDER_ID, PROJECTS_STAGED_FILES_RECEIVE } from 'DesignData/actions/ActionTypes';
import { createFolder, deleteFolder, fetchOpenFolders } from 'DesignData/actions/finder/Folders';
import { create as createRawAsset } from 'DesignData/actions/RawAssets';
import { setActiveThemeFolderId } from 'DesignData/actions/finder/Themes';
import { projectConfigTemplate } from 'DesignData/lib/projects/projects';
import { deployProject } from 'DesignData/api/finder/FileMapper';
import { fetchStagedFiles as projectsFetchStagedFiles } from 'DesignData/api/Projects';
export function setActiveProjectFolderId(folderId = null) {
  return dispatch => {
    if (folderId) {
      dispatch(setActiveThemeFolderId(null));
    }

    return dispatch({
      type: FINDER_PROJECTS_SET_ACTIVE_PROJECT_FOLDER_ID,
      folderId
    });
  };
}

function createConfig(projectFolderPath) {
  const configJsonPath = `${projectFolderPath}/hsproject.json`;
  const configJsonSource = projectConfigTemplate({
    label: projectFolderPath
  });
  return createRawAsset(configJsonPath, configJsonSource);
}
/**
 * Creates a hsproject.json file within a project
 */


export function createProjectsFolder(projectData = {}) {
  const {
    request,
    receive,
    error
  } = createProjectsFolder;
  const {
    folderName,
    parentFolderId
  } = projectData;
  return dispatch => {
    dispatch(request(projectData)); // Create the project folder

    const createFolderReq = dispatch(createFolder(folderName, parentFolderId));
    return createFolderReq.then(({
      folder,
      error: err
    }) => {
      if (err) {
        dispatch(error(projectData, err));
        return Promise.reject(err);
      }

      const handleError = __error => {
        dispatch(deleteFolder(folder.id, parentFolderId));
        dispatch(error(projectData, __error));
        return Promise.reject(err);
      };

      const onConfigCreateSuccess = configResp => {
        if (configResp.error) {
          return handleError(configResp.error);
        }

        return dispatch(receive({
          folder,
          folderName,
          configJson: configResp.rawAsset,
          parentFolderId
        }));
      };

      return dispatch(createConfig(folder.fullPath)).then(onConfigCreateSuccess);
    });
  };
}

createProjectsFolder.request = ({
  folderName
}) => {
  return {
    type: FINDER_PROJECTS_CREATE_REQUEST,
    folderName
  };
};

createProjectsFolder.error = ({
  folderName
}, error) => {
  return {
    type: FINDER_PROJECTS_CREATE_ERROR,
    folderName,
    error
  };
};

createProjectsFolder.receive = ({
  folder,
  folderName,
  configJson,
  parentFolderId
}) => {
  return {
    type: FINDER_PROJECTS_CREATE_RECEIVE,
    folder,
    parentFolderId,
    folderName,
    configJson
  };
};

export function deployProjectsFolder(folderPath, stagedFiles) {
  const {
    request,
    receive,
    error
  } = deployProjectsFolder;
  return dispatch => {
    const handleError = err => {
      dispatch(error(folderPath, stagedFiles, err));
    };

    const handleSuccess = deployResp => {
      if (deployResp.result === 'FAILURE') {
        handleError(deployResp);
        return deployResp;
      }

      dispatch(receive(folderPath, stagedFiles, deployResp));
      dispatch(fetchOpenFolders());
      return deployResp;
    };

    dispatch(request(folderPath, stagedFiles));
    return deployProject(folderPath).then(handleSuccess, handleError);
  };
}

deployProjectsFolder.request = (folderPath, stagedFiles) => {
  return {
    type: FINDER_PROJECTS_DEPLOY_REQUEST,
    folderPath,
    stagedFiles
  };
};

deployProjectsFolder.error = (folderPath, stagedFiles, error) => {
  return {
    type: FINDER_PROJECTS_DEPLOY_ERROR,
    folderPath,
    stagedFiles,
    error
  };
};

deployProjectsFolder.receive = (folderPath, stagedFiles, deployResp) => {
  return {
    type: FINDER_PROJECTS_DEPLOY_RECEIVE,
    folderPath,
    stagedFiles,
    deployResp
  };
};
/**
 * Fetches a list of staged files for the associated project
 */


export function fetchStagedFiles(projectPath) {
  return dispatch => {
    return projectsFetchStagedFiles(projectPath).then(stagedFiles => {
      return dispatch({
        type: PROJECTS_STAGED_FILES_RECEIVE,
        projectPath,
        stagedFiles
      });
    });
  };
}